import { languages } from "../../i18n/i18n.constants";
import countries from "i18n-iso-countries";
import { i18n } from "../../i18n/i18n";

export const mapLangToCountryCode = (lang: string) => {
    let coutryCode = "";
    switch (lang) {
        case languages.en:
            coutryCode = "us";
            break;
        case languages.pl:
            coutryCode = "pl";
            break;
        case languages.uk:
            coutryCode = "ua";
            break;

        default:
            coutryCode = lang;
            break;
    }
    return coutryCode;
}

export const getCountryNameByCode = (countryCode: string): string => {
    return countries.getName(countryCode, i18n.language) ?? countryCode;
};